import { useEffect, useRef, useState } from "react";
import useCameraList from "./hooks/useCameraList";
import { Link } from "react-router-dom";
import axios from "axios";
import fetchProfile from "../../../api/userProfile";
import sortedData from "../../../util/sortedData";
import FilterDropdown from "../../../components/atoms/filterDropdown/FilterDropdown";
import { DynamicTable } from "../../../components/table/dynamicTable";

const CameraList = () => {
  const {
    data,
    loading,
    currentPage,
    nextPage,
    count,
    handleDeleteClick,
    columns,
    tableData,
    setTableData,
    isFetchingComplete,
  } = useCameraList(0);

  const [isFetching, setIsFetching] = useState(false);
  const [sortBy, setSortBy] = useState("cameraId");
  const [sortDirection, setSortDirection] = useState("asc");
  const observer = useRef<IntersectionObserver | null>(null);
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const [profile, setProfile] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    const profileData = await fetchProfile();
    setProfile(profileData);
  };

  useEffect(() => {
    if (!profile) return;
    if (loading || isFetchingComplete) return;

    const tableElement = document.getElementById("table");
    const scrollTriggerDivElement =
      document.getElementById("scroll-trigger-div");

    if (tableElement && scrollTriggerDivElement) {
      scrollTriggerDivElement.style.width = tableElement.clientWidth + "px";
    }

    const handleObserver = (entries: IntersectionObserverEntry[]) => {
      const target = entries[0];
      if (target.isIntersecting) {
        loadMoreData();
      }
    };

    observer.current = new IntersectionObserver(handleObserver, {
      threshold: 0.2,
    });

    const scrollTriggerElement = document.getElementById("scroll-trigger");
    if (scrollTriggerElement) {
      observer.current.observe(scrollTriggerElement);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [loading, currentPage, isFetching, profile]);

  const loadMoreData = async () => {
    if (!isFetching && currentPage < Number(count) / 10 - 1) {
      setIsFetching(true);
      await nextPage();
      setIsFetching(false);
    }
  };

  const downloadExcel = async () => {
    alert("다운로드가 진행 중입니다.");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/camera/download-excel`,
        {},
        {
          responseType: "blob",
        }
      );

      // 파일 다운로드를 위한 Blob 생성
      const blob = new Blob([response.data], { type: "text/xlsx" });
      const url = window.URL.createObjectURL(blob);

      // 다운로드 링크 생성 및 클릭
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "카메라_테이블.xlsx");
      document.body.appendChild(link);
      link.click();

      // 생성된 URL 해제
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error creating xlsx:", error);
    }
  };

  const handleReset = () => {
    setSortBy("cameraId");
    setSortDirection("asc");
    setSearchTerm("");
    setStatusFilter("all");
  };

  return (
    <div className="container">
      <>
        <button className="excelButton" onClick={downloadExcel}>
          엑셀 다운로드
        </button>
        <div className="header">
          <h1>카메라 리스트</h1>
          <FilterDropdown
            columns={columns}
            searchTerm={searchTerm}
            tableData={tableData}
            allData={data}
            setTableData={setTableData}
          />
        </div>
        <div className="table-container">
          <DynamicTable data={tableData} />
          <div id="scroll-trigger-div">
            <div id="scroll-trigger" />{" "}
          </div>
        </div>
      </>
    </div>
  );
};

export default CameraList;
